var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-input",
        _vm._b(
          {
            ref: "input",
            staticClass:
              "text-area-rounded-0 text-area-border-0 word-break-normal",
            attrs: { value: _vm.value, readonly: _vm.readonly },
            on: { input: (e) => this.$emit("input", e) },
          },
          "el-input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _vm._t("attachments"),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mx-2 my-1 line-height-10" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1 d-flex gap-2 align-items-center" },
          [
            _vm._t("bottom-left-tools-before"),
            _vm._v(" "),
            _c(
              "placeholders",
              {
                attrs: { disabled: _vm.readonly, multiple: false },
                on: { select: _vm.insertPlaceholder },
              },
              [
                _c(
                  "Button",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      title: "Add placeholders",
                    },
                  },
                  [_c("i", { staticClass: "fas fa-code fa-fw" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "Emoji",
              {
                attrs: { disabled: _vm.readonly, multiple: true },
                on: { select: _vm.insertEmoji },
              },
              [
                _c(
                  "Button",
                  { attrs: { disabled: _vm.readonly, title: "Add emoji" } },
                  [_c("i", { staticClass: "far fa-smile fa-fw" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("bottom-left-tools-after"),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-shrink-0" },
          [_vm._t("bottom-right-tools")],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }